module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    attrs: {
      "id": "bandeau"
    }
  }, [_c('info', {
    attrs: {
      "counter": _vm.counter,
      "numberOfAliveCells": _vm.numberOfAliveCells,
      "errorMessage": _vm.errorMessage
    }
  }), _vm._v(" "), _c('creation', {
    on: {
      "click": _vm.newCreate
    }
  }), _vm._v(" "), _c('command-container', {
    on: {
      "refresh": _vm.refresh,
      "refreshAutomatic": _vm.refreshAutomatic,
      "stopRefreshAutomatic": _vm.stopRefreshAutomatic
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('grid', {
    attrs: {
      "cells": _vm.cells,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67a46985!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 25
// module chunks = 1